module.exports = __webpack_public_path__ + "static/media/0023_IMG_LE_PLAFOND_CHROMATIC_CH2_1039.a5f08e38.png";